import { z } from 'zod';
import { pageOf } from '#src/common/pagination.contract.js';
import { messageContentSchema } from '#src/messages/send-message.contract.js';
import { actorSchema } from '#src/routines/routines.contract.js';
/** Instante em ISO 8601, UTC. */
const instantSchema = z.iso.datetime();
/**
 * De onde veio o envio:
 * - `routine`: uma execução de rotina (agendada, manual ou pelo CLI);
 * - `manual`: "Enviar para…" no painel da pessoa;
 * - `preview`: a prévia que alguém mandou para si;
 * - `test`: o lembrete de teste por números de chamado;
 * - `api`: chamada direta à API (`POST /api/messages`, envio por corpo);
 * - `resend`: reenvio de um disparo anterior.
 */
export const deliverySourceSchema = z.enum([
    'routine',
    'manual',
    'preview',
    'test',
    'api',
    'resend',
]);
/**
 * `queued`: na fila; `sending`: tentando entregar (as tentativas contam);
 * `sent`: entregue ao Teams; `failed`: desistiu, com o motivo.
 */
export const deliveryStatusSchema = z.enum([
    'queued',
    'sending',
    'sent',
    'failed',
]);
export const deliverySchema = z.strictObject({
    id: z.uuid(),
    recipientEmail: z.string(),
    /** Texto curto da mensagem: o da notificação, ou o início do texto. */
    summary: z.string(),
    source: deliverySourceSchema,
    status: deliveryStatusSchema,
    attempts: z.int().nonnegative(),
    createdAt: instantSchema,
    /** Quando terminou, entregue ou não. */
    finishedAt: instantSchema.nullable(),
    /** Motivo da falha, sem detalhe técnico (que fica no log). */
    error: z.string().nullable(),
    /** `null` para rotinas agendadas e integrações. */
    requestedBy: actorSchema.nullable(),
    routineRunId: z.uuid().nullable(),
    /** O disparo que este reenviou. */
    resendOf: z.uuid().nullable(),
});
/** Um disparo com a mensagem inteira, para a prévia e o reenvio. */
export const deliveryDetailSchema = deliverySchema.extend({
    content: messageContentSchema,
});
export const deliveriesPageSchema = pageOf(deliverySchema);
/** Contagens das últimas 24 horas, para os indicadores da tela. */
export const deliveryStatsSchema = z.strictObject({
    since: instantSchema,
    sent: z.int().nonnegative(),
    failed: z.int().nonnegative(),
    /** Na fila ou tentando agora. */
    pending: z.int().nonnegative(),
});
//# sourceMappingURL=deliveries.contract.js.map